module.exports = __webpack_public_path__ + "img/12.b9381e92.jpg";